import React from 'react';

export default function Settings({ user }) {
  return (
    <section className="space-y-6 max-w-2xl">
      <h1 className="text-2xl font-semibold">Settings</h1>

      <div className="rounded-lg border bg-white p-4">
        <h2 className="font-medium mb-2">Profile</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="text-sm">
            <span className="block text-gray-600 mb-1">Name</span>
            <input className="w-full border rounded-md h-9 px-3" defaultValue={user?.name || ''} />
          </label>
          <label className="text-sm">
            <span className="block text-gray-600 mb-1">Email</span>
            <input className="w-full border rounded-md h-9 px-3" defaultValue={user?.email || ''} disabled />
          </label>
        </div>
        <div className="mt-4 flex gap-2">
          <button className="h-9 px-3 rounded-md bg-gray-900 text-white">Save</button>
          <button className="h-9 px-3 rounded-md border">Cancel</button>
        </div>
      </div>

      <div className="rounded-lg border bg-white p-4">
        <h2 className="font-medium mb-2">Preferences</h2>
        <div className="flex items-center gap-3">
          <label className="inline-flex items-center gap-2">
            <input type="checkbox" />
            <span className="text-sm">Dark mode (coming soon)</span>
          </label>
        </div>
      </div>
    </section>
  );
}
